import apiHeader from '@/helpers/apiHeader';

const plantLocationsService = {
    list(page, params) {
        return apiHeader.get(`plant-locations?page=${page}`, { params }); // Ambil daftar plant locations dengan pagination
    },
    get(id) {
        return apiHeader.get(`plant-locations/${id}`); // Ambil plant location berdasarkan ID
    },
    update(params) {
        return apiHeader.post('plant-locations/', params);
    },
}

export default plantLocationsService;